// src/styles/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';
import './GlobalStyles.css';

const GlobalStyles = createGlobalStyle`
  :root {
    --font-primary: 'Open Sans', sans-serif;
    --font-secondary: 'Roboto Slab', serif;
    --color-primary: #a7401a;
    --color-secondary: #ef997a;
    --color-dark: #182c25;
    --color-light: #f5f5f5;
    --color-white: #ffffff;
  }
`;

export default GlobalStyles;